export const BASE_FILE_URL = "https://file.heoxasoft.com/";

export const UNIQUE_KEY = "TmsCoolZoneApp";
